import PageLoadedQueue from "../Project/PageLoadedQueue";

export function textareaResize(textarea: HTMLTextAreaElement) {
    textarea.addEventListener('input', autoResize, false);
    textarea.addEventListener('click', autoResize, false);

    function autoResize() {
        this.style.height = 'auto';
        this.style.height = this.scrollHeight + 'px';
    }
}

export function initTextareaResize() {
    const textareas = document.querySelectorAll('textarea[data-autoresize="1"],textarea[data-autoresize="true"]');
    textareas.forEach(textarea => textareaResize(textarea as HTMLTextAreaElement));
}

PageLoadedQueue.addFunction(initTextareaResize);
